// extracted by mini-css-extract-plugin
export default {"rowContainer":"PatientsTable_rowContainer__a4Jtv"};